import type { ReactNode } from 'react';

/** The 56px field the signed-out screens share. */
export const fieldClass =
  'mb-3.5 h-[56px] w-full rounded-control border border-line-strong bg-white px-4 text-[15px] ' +
  'font-bold outline-none placeholder:font-normal placeholder:text-subtle ' +
  'focus:border-brand-bright md:text-[16.5px]';

/**
 * The frame the signed-out screens share.
 *
 * Same head as the app itself, so signing in already looks like the thing you
 * are signing in to.
 */
export default function AuthShell({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="mx-auto flex min-h-[100dvh] max-w-[430px] flex-col bg-canvas">
      <header className="rounded-b-[34px] border border-line-strong bg-white px-[22px] pt-[calc(56px+env(safe-area-inset-top))] pb-9">
        <span
          aria-hidden
          className="mb-5 flex size-11 items-center justify-center rounded-[14px] bg-brand-bright"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M20 4c0 9-5.5 13-10.5 13S4 15 4 15s2-9 9.5-10C17 4.6 20 4 20 4Z" fill="#fff" />
          </svg>
        </span>
        <h1 className="text-[27px] font-extrabold tracking-[-0.04em] md:text-[32px]">{title}</h1>
        <p className="mt-2 text-[13.5px] leading-[1.5] text-muted md:text-[15px]">{subtitle}</p>
      </header>

      <div className="flex min-h-0 flex-1 flex-col px-[22px] pt-6 pb-6">
        {children}

        <p className="mt-auto pt-6 text-center text-[13px] font-bold text-subtle md:text-[14.5px]">
          {footer ?? 'MealDesk'}
        </p>
      </div>
    </div>
  );
}
